export default __webpack_public_path__ + "static/media/4522.4f916b48.png";